import React from 'react';

const NormalFooter: React.FC = () => {
  return (
    <footer className="mt-auto border-t border-gray-200 bg-gray-50">
      <div className="mx-auto max-w-5xl px-4 py-6 text-sm text-gray-500 sm:px-6">
        © {new Date().getFullYear()} Morichika Clinic. All rights reserved.
      </div>
    </footer>
  );
};

export default NormalFooter;
